import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useBusinessAuth } from '@/context/BusinessAuthContext';

export default function BusinessProtectedRoute({ children }) {
  const { user, loading } = useBusinessAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-8 h-8 text-teal-600 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/partner/login" replace />;
  }

  return children;
}
